let touchEvent = 'ontouchstart' in window ? 'touchstart' : 'click';
document.querySelectorAll('.accordion__button').forEach(function(accordion) {
    accordion.addEventListener(touchEvent, function (){
        if ( 'true' !== accordion.getAttribute( 'aria-expanded' ) ) {
            accordion.setAttribute('aria-expanded',true);
        } else {
            accordion.setAttribute('aria-expanded',false);
        }
    });
});